import { CHANGE_FILTER, CHANGE_DATALIST, CHANGE_MUTEX, CHANGE_VALUES, SET_INITIAL_STATE, SET_NEW_URL_STATE, CHANGE_MARCA, RESET_APPLICATION } from "../actionTypes";

const common = require('../../components/common/common');

const initialState = initState();

const appFilters = (state = initialState, action) => {
  var newState = {};
  switch (action.type) {
    case CHANGE_FILTER:
      newState = Object.assign({}, state);
      newState.filtersState[action.name] = action.value;
    break;
    case CHANGE_DATALIST:
      newState = Object.assign({}, state);
      newState.dataList[action.name] = action.value;
    break;
    case CHANGE_MUTEX:
      newState = Object.assign({}, state);
      newState.renewMutex[action.name] = action.value;
    break;
    case CHANGE_VALUES:
      newState = Object.assign({}, state);
      if (typeof action.value === 'object'){
        Object.keys(action.value).forEach((index) => {
          var value = action.value[index];
          if(newState.hasOwnProperty(index)){
            Object.keys(value).forEach((index1) => {
              var value1 = value[index1];
              newState[index][index1] = value1;
            });
          }else{
            newState[index] = value;
          }
        })
      }
    break;
    case SET_INITIAL_STATE:
      newState = initState();
    break;
    case SET_NEW_URL_STATE:
      newState = initState();
      newState.dataList.wishList = state.dataList.wishList;
      newState.renewMutex.newUrl = true;
      newState.filtersState.marca = action.value.marca;
      newState.filtersState.modello = action.value.modello;
      newState.filtersState.tavola = action.value.tavola;
      newState.filtersState.immagine = action.value.immagine;
      newState.filtersState.distintaGruppo = action.value.distintaGruppo;
      newState.filtersState.distintaTavola = action.value.distintaTavola;
      newState.filtersState.applicazione = action.value.applicazione;
    break;
    case CHANGE_MARCA:
      newState = initState();
      newState.dataList.wishList = state.dataList.wishList;
      newState.filtersState.marca = action.value;
    break;
    case RESET_APPLICATION:
      var i=0;
      newState = Object.assign({}, state);
      newState.renewMutex.applicazioni = true;
      newState.renewMutex.tavole = true;
      newState.renewMutex.modelli = false;
      newState.filtersState.applicazione = "";
      newState.filtersState.tavola = "";
      newState.filtersState.modello = "";
      newState.dataList.applicazioni = [];
      var modelli = state.dataList.modelli;
      for(i=0;i<modelli.length; i++){
        modelli[i].visibile = true;
      }
      var tavole = state.dataList.tavole;
      for(i=0;i<tavole.length; i++){
        tavole[i].visibile = true;
      }
      newState.dataList.tavole = tavole;
      newState.dataList.modelli = modelli;
    break;
    default:
      newState = Object.assign({}, state);
  }
  return newState;
};

function getWishList() {
  var out = [];
  try {
    var wishList = common.get_localStorage("wishList");
    if (wishList != undefined && wishList != null && wishList != "")
      out = JSON.parse(common.get_localStorage("wishList"))
    
    return out;
  } catch (error) {
    return out;
  }  
}

function initState(){
  return {
    filtersState : {
      marca : '',
      telaio: '',
      cmoto: '',
      applicazione : '',
      modello : '',
      tavola : '',
      immagine: '',
      distintaGruppo: '',
      distintaTavola: '',
    },
    dataList : {
      modelli: [],
      applicazioni: [],
      tavole: {},
      distinta: {},
      immagineTavola: [],
      wishList: getWishList(),
    },
     renewMutex : {
      mostraImg: false,
      applicazioni: true,
      modelli: true,
      modelliApp: false,
      tavoleApp: false,
      tavole: true,
      distinta: true,
      immagineTavola: true,
      newUrl: false,
      init: false,
    },
  };
}

export default appFilters;
